const translations = {
    // Hero Section - முதன்மை பகுதி
    "unlock_cosmic": "ஸ்ரீ ஆஸ்ட்ரோ வேதா",
    "personalized_predictions": "ராசி அறிகுறிகளிலிருந்து வாழ்க்கையின் பெரிய பதில்கள் வரை",
    "hero_description": "பண்டைய ஞானம் உங்கள் நவீன வாழ்க்கையை சந்திக்கும் இடம் - ஜாதகம், எண்ணியல், உங்கள் காதல் வாழ்க்கை மற்றும் தசா பலன் வாசிப்புகளை ஆராய்ங்கள், அனைத்தும் சான்றளிக்கப்பட்ட ஜோதிட நிபுணர்களால் உங்கள் பாதையை தெளிவு மற்றும் நோக்கத்துடன் வழிநடத்த உருவாக்கப்பட்டுள்ளது.",
    "get_my_report": "முழு அறிக்கை பெறுங்கள்",
    "view_sample": "மாதிரி அறிக்கை பார்க்கவும்",

    // Features - அம்சங்கள்
    "detailed_reports": "2026 தனிப்பட்ட வாழ்க்கை அறிக்கை",
    "horoscope_matching": "குண்டலி பொருத்தம்",
    "astrology_systems": "ஜாதகம், எண்ணியல், தசா மற்றும் பலவும்",
 
    // Modal - மாதிரி
    "200_pages": "200க்கும் மேற்பட்ட நுண்ணறிவு பக்கங்கள்",
    "20_years_predictions": "20 ஆண்டுகள் எதிர்கால முன்கணிப்புகள்",
    "personalized_kundli": "உங்கள் தனிப்பட்ட வேத வாழ்க்கை அறிக்கை",
    "most_detailed_india": "முழுமையான மற்றும் விரிவான வழிகாட்டுதல்",
    "cosmic_blueprint_description": "உங்கள் வாழ்க்கையின் பயணம் இதன் மூலம் புரிந்துகொள்ளப்படுகிறது:",

    "predictions_doshas_remedies": "ஜாதகம், தசைகள், நட்சத்திரங்கள், எண்ணியல், லால் கிதாப், உங்கள் காதல் வாழ்க்கை, தொழில், ஆரோக்கிய குறியீடு, சாடே சதி, பரிகாரங்கள் மற்றும் பலவற்றின் விரிவான நுண்ணறிவுகள்.",
    "customized_for_you": "ஸ்ரீ ஆஸ்ட்ரோ வேதாவால் உங்களுக்காக மட்டுமே உருவாக்கப்பட்ட ஒரு தெய்வீக அறிக்கை",
    "check_sample_kundli": "அறிக்கையை ஆராயுங்கள்",

    // Section Title & Description - பகுதி தலைப்பு மற்றும் விளக்கம்
    "authentic_vedic_astrology": "ஸ்ரீ ஆஸ்ட்ரோ வேதா ஜோதிட சேவைகள்",
    "cosmic_destiny": "உங்கள் விதி, புரிந்துகொள்ளப்பட்டு",
    "through_ancient_wisdom": "வேத ஜோதிடத்தின் நித்திய ஞானத்தால் வழிநடத்தப்பட்டது",
    "two_section_description": "ஸ்ரீ ஆஸ்ட்ரோ வேதா ஜோதிடத்தின் பண்டைய அறிவியல் மூலம் அறிவார்ந்த வாழ்க்கை தேர்வுகளைச் செய்ய உங்களுக்கு உதவுகிறது - விரிவான குண்டலி பகுப்பாய்வு, எண்ணியல், தசா காலவரிசை, உங்கள் காதல் வாழ்க்கை மற்றும் சக்திவாய்ந்த லால் கிதாப் பரிகாரங்களை இணைக்கிறது. தெளிவு மற்றும் நம்பிக்கையுடன் உங்கள் பாதையைக் கண்டுபிடியுங்கள்.",

    // Features - அம்சங்கள்
    "personalized_birth_charts": "உங்கள் உண்மையான சுயத்தைப் புரிந்துகொள்ளுங்கள்",
    "personalized_birth_charts_desc": "மறைக்கப்பட்ட பலங்கள், பலவீனங்கள் மற்றும் வாழ்க்கை முறைகளை வெளிப்படுத்த உங்கள் ஜாதக, லக்னம் மற்றும் கிரக நிலைகளின் முழுமையான பகுப்பாய்வைப் பெறுங்கள்.",

    "remedial_gemstone_guidance": "வாழ்க்கையின் தடைகளை கடந்து செல்லுங்கள்",
    "remedial_gemstone_guidance_desc": "கிரக சமநிலையின்மையை நடுநிலையாக்கவும் சாதகமான முடிவுகளை ஈர்க்கவும் பயனுள்ள பரிகாரங்கள், ரத்தின ஆலோசனைகள் மற்றும் சாடே சதி பகுப்பாய்வைப் பெறுங்கள்.",

    "marriage_compatibility_analysis": "இணக்கமான உறவுகளைக் கண்டுபிடியுங்கள்",
    "marriage_compatibility_analysis_desc": "உறவு இயக்கவியல் புரிந்துகொள்ளவும் நீண்ட கால இணக்கத்தை உறுதிப்படுத்தவும் எங்கள் மேம்பட்ட காதல் மற்றும் திருமண இணக்க கருவிகளை பயன்படுத்துங்கள்.",

    "career_life_predictions": "நம்பிக்கையுடன் உங்கள் எதிர்காலத்தைத் திட்டமிடுங்கள்",
    "career_life_predictions_desc": "தொழில், ஆரோக்கியம், நிதி மற்றும் ஆண்டு போக்குகள் பற்றிய துல்லியமான முன்கணிப்புகளைப் பெறுங்கள், அதனால் நீங்கள் முன்கூட்டியே திட்டமிடலாம் மற்றும் அதிகாரமளிக்கும் முடிவுகளை எடுக்கலாம்.",

    // CTA & Trust - அழைப்பு மற்றும் நம்பிக்கை
    "start_your_journey": "உங்கள் ராசி பாதையைத் திறக்கவும்",
    "learn_more": "முழு சேவைகளை ஆராயுங்கள்",
    "rated_by_clients": "10,000+ வாடிக்கையாளர்களால் 5-ல் 4.9 மதிப்பீடு",
    "confidential_secure": "100% ரகசிய மற்றும் பாதுகாப்பான",

    "authentic_astrology_banner": "அசல் ஜோதிட சேவைகள்",

    // Service Cards - சேவை அட்டைகள்
    "match_kundli": "குண்டலி பொருத்தம்",
    "match_kundli_desc": "உங்களுக்கும் உங்கள் துணையருக்கும் திருமண இணக்கம் மற்றும் குண்டலி பொருத்தத்தைச் சரிபார்க்கவும்.",
    "match_now": "இப்போது பொருத்தம் பார்க்கவும்",

    "your_life_predictions": "உங்கள் வாழ்க்கை முன்கணிப்புகள்",
    "life_predictions_desc": "உங்கள் ஜாதகத்தின் அடிப்படையில் உங்கள் எதிர்காலத்தின் முழுமையான மேலோட்டத்தைப் பெறுங்கள்.",
    "view_predictions": "முன்கணிப்புகளைப் பார்க்கவும்",

    "ask_question_price": "ஒரு கேள்வி கேளுங்கள்",
    "ask_question_desc": "எந்த தனிப்பட்ட அல்லது அவசர கேள்விக்கும் நிபுணர் பதில்களைப் பெறுங்கள்.",
    "ask_now": "இப்போது கேளுங்கள்",

    "career_guidance": "தொழில்",
    "career_desc": "உங்கள் நட்சத்திரங்களின் அடிப்படையில் சரியான தொழில் பாதை மற்றும் வேலை வாய்ப்புகளைக் கண்டுபிடியுங்கள்.",
    "explore_career": "தொழிலை ஆராயுங்கள்",

    "love_compatibility": "காதல்",
    "love_desc": "உங்கள் காதல் வாழ்க்கை, உறவு இணக்கம் மற்றும் எதிர்கால காதலைப் புரிந்துகொள்ளுங்கள்.",
    "check_love_life": "காதல் வாழ்க்கையைச் சரிபார்க்கவும்",

    "2026_personalized_report": "2026 தனிப்பட்ட அறிக்கை",
    "2026_report_desc": "உங்கள் பிறப்பு விவரங்களுக்கு ஏற்ப விரிவான வார்ஷிக முன்னறிவிப்பு.",
    "get_2026_report": "2026 அறிக்கை பெறுங்கள்",

    "dasha_phal_analysis": "தசா பலன் பகுப்பாய்வு",
    "dasha_analysis_desc": "உங்கள் வாழ்க்கையில் கிரக காலங்களின் (தசைகள்) தாக்கத்தைப் புரிந்துகொள்ளுங்கள்.",
    "analyze_now": "இப்போது பகுப்பாய்வு செய்யுங்கள்",

    "sade_sati_report": "சாடே சதி வாழ்க்கை அறிக்கை",
    "sade_sati_desc": "சனியின் சாடे சதி உங்களை எப்படி பாதிக்கும் என்பதைக் கண்டுபிடித்து பரிகாரங்களைப் பெறுங்கள்.",
    "check_sade_sati": "சாடே சதியைச் சரிபார்க்கவும்",

    // Daily Horoscope Section - தினசரி ராசிபலன் பகுதி
    "free_daily_horoscope": "ஒவ்வொரு ராசி, ஒவ்வொரு ரகசியம் - நட்சத்திரங்கள் உங்களைப் பற்றி என்ன சொல்கிறது என்பதைக் கண்டுபிடியுங்கள்",
    "horoscope_categories": "",

    // Zodiac Signs - ராசி அறிகுறிகள்
    "aries": "மேஷம்",
    "taurus": "ரிஷபம்",
    "gemini": "மிதுனம்",
    "cancer": "கடகம்",
    "leo": "சிம்மம்",
    "virgo": "கன்னி",
    "libra": "துலாம்",
    "scorpio": "விருச்சிகம்",
    "sagittarius": "தனுசு",
    "capricorn": "மகரம்",
    "aquarius": "கும்பம்",
    "pisces": "மீனம்",

    // Date Ranges - தேதி வரம்புகள்
    "aries_dates": "மார் 21 - ஏப் 19",
    "taurus_dates": "ஏப் 20 - மே 20",
    "gemini_dates": "மே 21 - ஜூன் 20",
    "cancer_dates": "ஜூன் 21 - ஜூல் 22",
    "leo_dates": "ஜூல் 23 - ஆக 22",
    "virgo_dates": "ஆக 23 - செப் 22",
    "libra_dates": "செப் 23 - அக் 22",
    "scorpio_dates": "அக் 23 - நவ 21",
    "sagittarius_dates": "நவ 22 - டிச 21",
    "capricorn_dates": "டிச 22 - ஜன 19",
    "aquarius_dates": "ஜன 20 - பிப் 18",
    "pisces_dates": "பிப் 19 - மார் 20",

    // Modal Content Keys - மாதிரி உள்ளடக்க விசைகள்
    "today_horoscope": "இன்றைய ராசிபலன்",
    "basic_info": "அடிப்படை தகவல்",
    "characteristics": "பண்புகள்",
    "lucky_elements": "அதிர்ஷ்ட கூறுகள்",
    "lucky_color": "அதிர்ஷ்ட நிறம்",
    "lucky_number": "அதிர்ஷ்ட எண்",
    "element": "மூலக்கூறு",
    "ruling_planet": "ஆட்சி கிரகம்",
    "get_detailed_reading": "விரிவான வாசிப்பைப் பெறுங்கள்",
    "more_insights": "மேலும் நுண்ணறிவுகள்",
    "likes": "விருப்பங்கள்",
    "dislikes": "வெறுப்புகள்",
    "food": "உணவு",
    "travel_style": "பயண பாணி",
    "movie_match": "திரைப்பட பொருத்தம்",
    "song_vibe": "பாடல் அதிர்வு",
    "celebs": "பிரபலங்கள்",

    // Aries Content - மேஷம் உள்ளடக்கம்
    "aries_horoscope": "இன்று உமக்கு நெருப்பு சக்தியும் புதிய வாய்ப்புகளும் கிடைக்கின்றன. உங்கள் தலைமைத்துவ திறன்கள் பிரகாசிக்கும், இது புதிய திட்டங்களைத் தொடங்க அல்லது சூழ்நிலைகளின் பொறுப்பை எடுத்துக்கொள்ள சிறந்த நாளாக அமைகிறது.",
    "aries_traits": "துணிச்சலான, போட்டியிடும், ஆற்றல் மற்றும் முன்முயற்சி நிறைந்த. எப்போதும் முதலில் நடவடிக்கை எடுப்பவர்.",
    "aries_likes": "வெற்றி, தலைமைத்துவம், உற்சாகம், சவால்கள்.",
    "aries_dislikes": "சோம்பல், தாமதம், தயக்கம்.",
    "aries_food": "காரமான உணவு, வறுத்த இறைச்சி, புரதம் நிறைந்த உணவுகள்.",
    "aries_travel_style": "சாகச விளையாட்டுகள், தனி ட்ரெக்கிங், சாலை பயணங்கள்.",
    "aries_movie_match": "மேட் மேக்ஸ்: ப்யூரி ரோட்",
    "aries_song_vibe": "ஐ ஆஃப் தி டைகர்",
    "aries_celebs": "லேடி காகா, அஜய் தேவ்கன், ராபர்ட் டவுனி ஜூனியர்",
    "aries_color": "சிவப்பு",
    "aries_number": "9",
    "aries_element": "நெருப்பு",
    "aries_planet": "செவ்வாய்",

     "taurus_horoscope": "இன்று விதைவைத்த நிம்மதி மற்றும் சுகத்தை அனுபவிப்பதற்கான சிறந்த நாள். நிலைத்தன்மையை கவனத்தில் கொண்டு, வாழ்க்கையின் finer விஷயங்களை ரசிப்பதால் நீடித்த பலனைப் பெறுவீர்கள்.",
  "taurus_traits": "அமைதியானவர், நம்பகத்தன்மை மிக்கவர், குணம்கொண்ட наслаж்சி, பேரன்புடையவர். ஆறுதல் மற்றும் செல்வச் சிறப்பை விரும்புவர்.",
  "taurus_likes": "இயற்கை, இசை, சுவையான உணவு, உயர்தர பொருட்கள்.",
  "taurus_dislikes": "எதிர்பாராத மாற்றம், அவசரப்படுத்தல், நிலைஇல்பு.",
  "taurus_food": "முக்கிய உணவுப்பொருட்கள், இனிப்புகள், குர்மே சீஸ், சாக்லெட்டுகள்.",
  "taurus_travel_style": "இயற்கை தங்குமிடங்கள், திராட்சைத் தோட்டங்கள், லக்ஷரி ரிசார்ட்கள்.",
  "taurus_movie_match": "The Hundred-Foot Journey",
  "taurus_song_vibe": "All of Me",
  "taurus_celebs": "கிகி ஹதீத், வருண் தவான், அடேல்",
  "taurus_color": "பச்சை & இளஞ்சிவப்பு",
  "taurus_number": "6",
  "taurus_element": "பூமி",
  "taurus_planet": "சுக்கிரன்",

  // Gemini – மிதுனம்
  "gemini_horoscope": "இன்று தொடர்பாடல் மிக முக்கியம். உங்கள் நுண்ணறிவும் முறுப்போக்கும் புதிய வாய்ப்புகளை உருவாக்கும். சayithi‌யங்கள் மற்றும் கருத்துப் பகிர்வுக்கு ஏற்ற நாள்.",
  "gemini_traits": "சமூகபண்பு, நையாண்டி மீள், தன்னிலையில் மாறும் திறன், விரைவான சிந்தனையாளர்கள், பல பணிகளை ஒரே நேரத்தில் கையாளுவோர்.",
  "gemini_likes": "பேச்சு, எழுதல், தொழில்நுட்பம், புதிய அனுபவங்கள்.",
  "gemini_dislikes": "மீளச்செய்தல், single-track routine, அமைதி.",
  "gemini_food": "கைபிடி உணவுகள், தெரு ஸ்நாக்ஸ், தனித்துவமான வகைகள்.",
  "gemini_travel_style": "சிறிய திடீர்த் பயணங்கள், நகரம் சுவைஅறிதல்.",
  "gemini_movie_match": "The Social Network",
  "gemini_song_vibe": "Levitating",
  "gemini_celebs": "அஞ்சலினா ஜோலி, கரண் ஜோகார், கான்யே வெஸ்ட்",
  "gemini_color": "மஞ்சள்",
  "gemini_number": "5",
  "gemini_element": "காற்று",
  "gemini_planet": "புதன்",

  // Cancer – கடகம்
  "cancer_horoscope": "இன்று உங்கள் உள்ளுணர்வு வழிகாட்டும். குடும்பம் மற்றும் வீட்டு விஷயங்கள் முன்னிலைப் பெறும். உங்களுக்கு உள்ள பரிவு மற்றவர்களுக்கு ஆறுதலளிக்கும்.",
  "cancer_traits": "ஆழமான உணர்ச்சி, பராமரிப்பு மனது, உள்ளுணர்ச்சி, குடும்பத்தை முன்னிட்டு நடப்பவர்.",
  "cancer_likes": "வீடு, மனஅருகிய உணவு, நினைவுகள், நெருங்கிய நண்பர்கள்.",
  "cancer_dislikes": "கடுமை, தனிமைப்படுத்தல், மாற்றம்.",
  "cancer_food": "வீட்டண்ண உணவுகள், அரிசிப் பதார்த்தங்கள், இனிப்புகள்.",
  "cancer_travel_style": "கடற்கரை வீடுகள், பண்பாட்டு மூதாட்டுச் சின்னங்கள், ஆன்மீக ஓய்விடங்கள்.",
  "cancer_movie_match": "The Notebook",
  "cancer_song_vibe": "Photograph",
  "cancer_celebs": "செலீனா கோமேஸ், பிரியங்கா சொப்ரா, டாம் ஹேங்ஸ்",
  "cancer_color": "வெள்ளை & வெண்கலம்",
  "cancer_number": "2",
  "cancer_element": "நீர்",
  "cancer_planet": "சந்திரன்",

  // Leo – சிம்மம்
  "leo_horoscope": "இன்று உங்கள் இயற்கையான கவர்ச்சி பிரகாசிக்கிறது. மேடையில் நிற்கவும், உங்கள் படைப்பாற்றலை வெளிப்படுத்தவும் தயங்காதீர்கள். பாராட்டும் புகழும் வந்து சேர்வது உறுதி.",
  "leo_traits": "தைரியசாலி, நாடகம் நேசிக்கும், இதயதிறன் கொண்ட, பிறப்பால் தலைவர். கவனத்தை நாடுகிறவர்.",
  "leo_likes": "திரையும், கொண்டாட்டங்கள், தலைமைத்துவம்.",
  "leo_dislikes": "புறக்கணிப்புப் பெறுதல், மந்தம், விமர்சனம்.",
  "leo_food": "அருப்புசிகரி உணவுகள், செறிவான இனிப்புகள், அபூர்வ வரவேற்பு செய்து தரும் உணவுகள்.",
  "leo_travel_style": "லக்ஷரி க்ரூஸ்கள், கலாச்சார ஊர்வலங்கள், சுடர்முகப் பயண இடங்கள்.",
  "leo_movie_match": "The Great Gatsby",
  "leo_song_vibe": "Uptown Funk",
  "leo_celebs": "ஜென்னிபர் லோபஸ், சைஃப் அலி கான், பராக் ஒபாமா",
  "leo_color": "தங்கம் & ஆரஞ்சு",
  "leo_number": "1",
  "leo_element": "நெருப்பு",
  "leo_planet": "சூரியன்",

  // Virgo – கன்னி
  "virgo_horoscope": "விவரக்கூர்மை இன்று பலன் தரும். உங்கள் பகுப்பாய்வு திறன் சிக்கலான பிரச்சினைகளைத் தீர்க்க உதவும். ஆரோக்கியம் மற்றும் ஒழுங்கமைப்பில் கவனம் செலுத்துங்கள்.",
  "virgo_traits": "சீர்மை விரும்பு, நடைமுறை யோசனை, புத்திசாலித்தனம், ஆரோக்கியக்கேள்விப்பட்டு இருப்போர்.",
  "virgo_likes": "பலப்பு, திட்டங்கள், உதவுதல், கற்றல்.",
  "virgo_dislikes": "கோளாறு, செயல்திறன் குறைவு, உணர்ச்சிப் புயல்கள்.",
  "virgo_food": "ஆரோக்கிய பவுட், சுத்த உணவு, சூப்புகள், ஸலாட்.",
  "virgo_travel_style": "வெல்னஸ் ரிசார்ட்கள், சுற்றுச்சூழல் உறைவிடங்கள், பாரம்பரிய தளங்கள்.",
  "virgo_movie_match": "The Imitation Game",
  "virgo_song_vibe": "Lovely",
  "virgo_celebs": "கியானூ ரீவ்ஸ், கரீனா கபூர், செண்டாயா",
  "virgo_color": "வெள்ளை & பூமி நிறங்கள்",
  "virgo_number": "6",
  "virgo_element": "பூமி",
  "virgo_planet": "புதன்",

  // Libra – துலாம்
  "libra_horoscope": "இன்றைய நாடையை சமநிலை மற்றும் ஒற்றுமை வழிநடத்தும். நீதி மற்றும் அழகில் கவனம் செலுத்தும்போது உறவுகள் மலரும். கலைச் செயல்பாடுகள் மகிழ்ச்சியை தரும்.",
  "libra_traits": "அழகிய, சமநிலையாக்குபவர், ரومان்டிக், அமைதியை நேசிக்கும், அழகுணர்வு கொண்டவர்.",
  "libra_likes": "கலை, ஃபேஷன், காதல், உரையாடல்.",
  "libra_dislikes": "முரட்டுத்தனம், வாதம், சமநிலை மீறல்.",
  "libra_food": "பேஸ்ட்ரிகள், வைன், சீஸ், லைட் பாஸ்தா.",
  "libra_travel_style": "பாரிஸ், வெனிஸ் – காதல் அல்லது ஃபேஷன் இலக்குகள்.",
  "libra_movie_match": "La La Land",
  "libra_song_vibe": "Just the Way You Are",
  "libra_celebs": "கிம் கார்டாஷியன், ரன்பீர் கபூர், ஹியூ ஜாக்மன்",
  "libra_color": "விண்ணிற & ரோஸ் பிங்க்",
  "libra_number": "7",
  "libra_element": "காற்று",
  "libra_planet": "சுக்கிரன்",

  // Scorpio – விருச்சிகம்
  "scorpio_horoscope": "ஆழமான மாற்றம் அலையாடுகிறது. உங்கள் உள்ளகக் கருத்தை நம்பவும், மாற்றத்தை தழுவிக்கொள்ளவும். உங்கள் தீவிரத்தன்மையும் váத்தமும் பெரும் முன்னேற்றங்களைக் கொண்டு வரும்.",
  "scorpio_traits": "மர்மமான, தீவிர, நம்பிக்கையுள்ள, ஆழமான உணர்ச்சி கொண்ட.",
  "scorpio_likes": "ரகசியங்கள், மாற்றம், váத்தம்.",
  "scorpio_dislikes": "பொய்யான்மை, மேன்மையில்லாதவர், துரோகம்.",
  "scorpio_food": "காரமான, வலுவான சுவை, டார்க் சாக்லெட், Suspense செய் உணவுகள்.",
  "scorpio_travel_style": "மறைந்த ரத்தினங்கள், குகைகள், ரகசிய கடற்கரை.",
  "scorpio_movie_match": "Gone Girl",
  "scorpio_song_vibe": "Take Me to Church",
  "scorpio_celebs": "ரயன் கோஸ்லிங், ஷாருக் கான், கேட்டி பேரி",
  "scorpio_color": "கருப்பு & ஆழ சிவப்பு",
  "scorpio_number": "8",
  "scorpio_element": "நீர்",
  "scorpio_planet": "செவ்வாய் & பிளூட்டோ",

  // Sagittarius – தனுசு
  "sagittarius_horoscope": "சாகசம் பேசுகின்றது. கற்றல் அல்லது பயணத்தின் மூலம் вашего ஹோரிசனை விரிவுபடுத்துங்கள். உங்கள் 낙optimισம் மற்றவரை பெரிதாக கனவு காண ஊக்குவிக்கும்.",
  "sagittarius_traits": "விடுதலையான், நகைச்சுவை, தத்துவப்பார்வை, 낙optimισம்.",
  "sagittarius_likes": "பயணம், சாகசம், உண்மை, ஆழமான உரையாடல்கள்.",
  "sagittarius_dislikes": "விதிமுறைகள், கூச்சல்கேள்வி, ஒரே மாதிரியான பழக்கம்.",
  "sagittarius_food": "Street food, பர்பிக்யூ, சர்வதேச சமையல்.",
  "sagittarius_travel_style": "Backpacking, பரம்பரை தவிற்பட்டசியங்கள், தனிப்பயணங்கள்.",
  "sagittarius_movie_match": "Into the Wild",
  "sagittarius_song_vibe": "Adventure of a Lifetime",
  "sagittarius_celebs": "டெய்லர் ஸ்விஃப்ட், தர்மேந்திர, பிராட் பிட்",
  "sagittarius_color": "ஊதா & டர்குயாய்ஸ்",
  "sagittarius_number": "9",
  "sagittarius_element": "நெருப்பு",
  "sagittarius_planet": "வியாழன்",

  // Capricorn – மகரம்
  "capricorn_horoscope": "கடின உழைப்பு மற்றும் ஒழுங்கு இன்று வெற்றியை தரும். உங்கள் முறைபூர்வமான அணுகுமுறை நீண்டகால சாதனைகளுக்குத் தளம் அமைக்கும். குறிக்கோளில் மனதை திரட்டுங்கள்.",
  "capricorn_traits": "அவைநுகர்ச்சி, முதிர்ச்சி, ஒழுங்குப்படும், காலத்தை மீறியவராக.",
  "capricorn_likes": "வெற்றி, கட்டமைப்பு, உண்மையுள்ள பாசம், பாரம்பரியம்.",
  "capricorn_dislikes": "மந்தம், பொய்யான்மை, சுருங்குவழிகள்.",
  "capricorn_food": "பாரம்பரிய உணவுகள், சூப்புகள், ரொட்டிகள், மெதுவாக சமைத்த உணவு.",
  "capricorn_travel_style": "மலைகள், வரலாற்றுப் புகழ்பெற்ற நகரங்கள், வணிக-உழைப்பு கலந்த பயணங்கள்.",
  "capricorn_movie_match": "The Pursuit of Happyness",
  "capricorn_song_vibe": "Hall of Fame",
  "capricorn_celebs": "தீபிகா படுகோண், ஹிருத்திக் ரோஷன், மிச்செல் ஒபாமா",
  "capricorn_color": "கடுப்பு நீலம் & பழுப்பு",
  "capricorn_number": "10",
  "capricorn_element": "பூமி",
  "capricorn_planet": "சனி",

  // Aquarius – கும்பம்
  "aquarius_horoscope": "குன்றான சிந்தனையும் மனிதநேயம் சார்ந்த முயற்சிகளும் முன்ன scènes. உங்கள் தனிப்பட்ட பார்வை பழைய பிரச்சினைகளுக்கு புதுக் தீர்வுகளைத் தரும். டப்பாக்காட்டைச் சிந்திக்கவும்.",
  "aquarius_traits": "காட்சிமிக்கவர், சுயாதீன, மரபுமீறிய, மனிதநேயம் கொண்டவர்.",
  "aquarius_likes": "புதிய கண்டுபிடிப்புகள், சமூகப் பயன் செயல்கள், கருத்துகள், சமூக உறவு.",
  "aquarius_dislikes": "click restrictions, kalappanaigal, ஒரே மாதிரி நாளாட்டி.",
  "aquarius_food": "வெகான்/செடிசார், ஃப்யூஷன் உணவு, ஸ்மூத்திகள்.",
  "aquarius_travel_style": "அதிநவீன நகரங்கள், தன்னார்வ சேவைச் சுற்றுலா, காரணம் உடைய சாலைப் பயணங்கள்.",
  "aquarius_movie_match": "The Matrix",
  "aquarius_song_vibe": "Radioactive",
  "aquarius_celebs": "ஓப்ரா வின்ஃப்ரே, பிரீதி ஜின்டா, ஹாரி ஸ்டைல்ஸ்",
  "aquarius_color": "எலக்ட்ரிக் ப்ளூ & அக்வா",
  "aquarius_number": "11",
  "aquarius_element": "காற்று",
  "aquarius_planet": "யுரேனஸ் & சனி",

  // Pisces – மீனம்
  "pisces_horoscope": "இன்று உங்கள் கற்பனை ஓட்டத்தை அனுப்பட்ட விடுங்கள். கனவுகளும் உள்ளுணர்வும் அழகான கண்டுபிடிப்புகளை வழிநடத்தும். உங்கள் இரக்கமான இயல்பை பலர் உணர்வர்.",
  "pisces_traits": "கருணையுள்ள, கனவான, கலைமிகு, உள்ளுணர்ச்சி கொண்ட.",
  "pisces_likes": "கலை, காதல் கதைகள், இசை, கனவுகள்.",
  "pisces_dislikes": "கடுமையான உண்மை, பெருஞ்சத்தம், முரண்பாடு.",
  "pisces_food": "கடல் உணவு, பாஸ்தா, நிம்மதி உணவு, ஐ스크ிரிம்.",
  "pisces_travel_style": "தென்பகுதிக் குடியிருப்புகள், ஓய்விடங்கள், நதிக்கரை ஓய்வுகள்.",
  "pisces_movie_match": "Life of Pi",
  "pisces_song_vibe": "Someone Like You",
  "pisces_celebs": "ரिहானா, ஆலியா பட்ட், ஜஸ்டின் பீபர்",
  "pisces_color": "லாவென்டர் & கடல்குறிஞ்சி",
  "pisces_number": "12",
  "pisces_element": "நீர்",
  "pisces_planet": "நெப்ட்யூன் & வியாழன்",

  // Reviews – மதிப்புரை
  "review_title": "எர்ஜி எக்சேஞ்ச்: அவர்களின் வார்த்தைகள், எங்களின் நன்றியறிவு",

  // Why Choose
  "why_choose": "ஏன் ஸ்ரீஆஸ்ட்ரோவைத் தேர்ந்தெடுக்க வேண்டும்",

  // FAQ – அடிக்கடி கேட்கப்படும் கேள்விகள்
  "unlimited_kundlis_question": "பல குண்டலிகளை கேட்டு உருவாக்க முடியுமா?",
  "unlimited_kundlis_answer": "மிகவும்! எத்தனை நபர்களுக்கான விவரங்களையும் சமர்ப்பிக்கலாம். ஒவ்வொரு கோரிக்கையும் தனிப்பட்ட PDF அறிக்கையாக விரிவாக தயாரித்து வழங்கப்படும்.",

  "kundli_reports_question": "குண்டலி அறிக்கையில் என்ன உள்ளது?",
  "kundli_reports_answer": "ஒவ்வொரு அறிக்கையும் **திறமையான முறையில் தயாரிக்கப்பட்ட PDF** ஆகும்; இதில் பிறப்புசுற்று, லக்ன பகுப்பாய்வு, தசா, கோச்சார், நட்சத்திரம், எண்ணியல், காதல் & தொழில் வழிகாட்டுதல், ஆரோக்கிய குறியீடு, லால் கிதாப் பரிகாரங்கள் மற்றும் பல அடங்கும்.",

  "saving_notes_question": "சேஷன் குறிப்புகள் அல்லது பரிகாரங்களை சேர்க்க முடியுமா?",
  "saving_notes_answer": "நிச்சயமாக. குறிப்பிட்ட பரிகாரங்கள், பின்வரும் குறிப்புகள் அல்லது கூடுதல் கருத்துக்கள் வேண்டும் என்றால் கோரிக்கையின் போது குறிப்பிடவும்.",

  "devices_question": "அறிக்கையை எவ்வாறு பெறுவேன்?",
  "devices_answer": "நீங்கள் விரும்பும் முறையில் **WhatsApp, Email அல்லது SMS** வழியாக **24 மணிநேரத்திற்குள்** PDF வடிவத்தில் பெறுவீர்கள்.",

  "data_safety_question": "என் தனிப்பட்ட தகவல்கள் பாதுகாப்பா?",
  "data_safety_answer": "ஆம். அனைத்து பயனர் தரவுகளும் **முழுமையாக ரகசியமாக** வைக்கப்படுகின்றன. உங்கள் தனியுரிமை எங்கள் முதன்மை முன்னுரிமை.",

  "advertising_question": "அறிக்கை விளம்பரமின்றிதானா?",
  "advertising_answer": "**100% விளம்பரமில்லை.** எங்கள் அறிக்கைகள் தூய, கவனம் கூடிய ஜோதிட நுண்ணறிவுகளை மட்டுமே வழங்குகின்றன.",

  "client_management_question": "என் கிளையண்டுகளுக்காக அறிக்கைகள் ஆர்டர் செய்யலாமா?",
  "client_management_answer": "ஆம்! நீங்கள் ஜோதிடர், ஆலோசகர் அல்லது வெல்ல்நஸ் கோச் ஆகிய எந்த துறையராக இருந்தாலும் உங்கள் கிளையண்டுகளுக்கான அறிக்கைகளை bulk அல்லது தொடர்ச்சியாக ஆர்டர் செய்யலாம்.",

  "customize_charts_question": "படவுரு ஸ்டைல் அல்லது லேஅவுட்டை தேர்வு செய்யலாமா?",
  "customize_charts_answer": "ஆம். **வட, தென், கிழக்கு இந்திய** ஜாதக வடிவங்கள் கிடைக்கின்றன. எழுத்துறை அளவு அல்லது நிற விருப்பங்களையும் கேட்கலாம்.",

  "discounts_question": "தள்ளுபடி ஏதாவது உள்ளதா?",
  "discounts_answer": "ஆம். **இரு கால தள்ளுபடிகள்**, **காம்போ ஆஃபர்கள்**, எப்போதும் வாங்கும் வாடிக்கையாளர்கள் மற்றும் ஜோதிடர்களுக்கான சிறப்பு கட்டணங்கள் உள்ளன. WhatsApp-இல் இணைந்திருக்கவும்.",

  "affiliate_question": "பிறரை பரிந்துரை செய்து வருமானம் சேர்க்கலாமா?",
  "affiliate_answer": "ஆம்! **ஸ்ரீஆஸ்ட்ரோவேதா அஃபிலியேட் திட்டத்தில்** சேர்ந்திருங்கள்; நண்பர்கள், கிளையண்டுகள், அல்லது உங்கள் ஆடிடரியன்ஸை பரிந்துரைப்பதன் மூலம் கமிஷன் சம்பாதிக்கலாம்.",

  "languages_question": "பற்பல உள்ளூர் மொழிகளில் அறிக்கை கிடைக்குமா?",
  "languages_answer": "ஆம். **இந்தி, ஆங்கிலம், தெலுங்கு, ಕನ್ನಡ, தமிழ், மராத்தி, பெங்காலி** மற்றும் கோரிக்கைப்படி பிற மொழிகளிலும் அறிக்கைகள் கிடைக்கும்.",

  "delivery_time_question": "எவ்வளவு சீக்கிரம் அறிக்கை எதிர்பார்க்கலாம்?",
  "delivery_time_answer": "விவரங்களை சமர்ப்பித்த 24 மணிநேரத்திற்குள் முழு அறிக்கையும் பெறுவீர்கள்; WhatsApp, Email அல்லது SMS வழி வழங்கப்படும்.",

  "services_question": "எந்த ஜோதிட சேவைகள் அடங்கும்?",
  "services_answer": "எங்கள் அறிக்கைகள் **ஜாதகம், குண்டலி பொருத்தம், லக்ன & தசா பகுப்பாய்வு, கோச்சார், நட்சத்திரம், எண்ணியல், தொழில் & காதல் வழிகாட்டுதல், ஆண்டு & தினசரி முன்கணிப்புகள், ஆரோக்கியச் குறியீடு, லால் கிதாப் பரிகாரங்கள், சாடே சதி அறிக்கைகள், தோஷா பகுப்பாய்வு, ரத்தின ஆலோசனைகள்** உள்ளிட்ட அதிவிரிவான உள்ளடக்கங்களை உள்ளடக்கியது.",

  // Audio Controls
  "unmute_first_card": "முதல் கார்டை ஒலியூட்டுக",
  "mute_first_card": "முதல் கார்டை மியூட் செய்யுக"
};

export default translations;